import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { IOTPCallSchema } from "../../Schemas/OTPCalls";

interface Filter extends IFilterSchema {
  column: OTPListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: OTPListColumnSortable;
}

export enum OTPListColumnFilterable {
  NUMBER = "number",
}

export enum OTPListColumnSortable {
  CREATED_AT = "created_at",
  ID="id"
}

export interface OTPListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}


export interface OTPListResponseBody extends IResponseBody {
  data: {
    otp_calls: IOTPCallSchema[];
    total: number;
  };
}

export class OTPListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/otp-calls`;
  }

  async send(
    queryStrings?: OTPListQueryString
  ): Promise<OTPListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
